import { Sections } from '../../types/Sections';
import { togglePage } from '../../helpers/togglePage';
import { MenuItems } from '../../types/MenuItems';
import { useEffect, useRef } from 'react';
import drum from '../../assets/images/drum.png';

import './SixInTix.scss';
import { Icons } from '../../components/Icons/Icons';
import { getTranslation } from '../../constants/translations';

type Blocks = 'six-content' | 'six-features';

export const SixInTix = () => {
  const content = useRef<HTMLDivElement>(null);
  const t = getTranslation();

  const goToElement = (id: Blocks) => {
    const element = document.getElementById(id) as HTMLElement;

    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  };

  useEffect(() => {
    const section = document.getElementById(Sections.SIXINTIX) as HTMLElement;

    if (window.location.hash.includes(Sections.SIXINTIX)) {
      let prevScrollY = 0;
      let allowScroll = true;
      let isTouchEnd = true;

      const handleChangeScroll = () => {
        const section = document.getElementById(
          Sections.SIXINTIX,
        ) as HTMLElement;

        const scrollY = section.scrollTop;

        if (!allowScroll) {
          prevScrollY = scrollY;
          return;
        }

        if (scrollY > prevScrollY) {
          if (section.scrollTop > 30 && isTouchEnd) {
            allowScroll = false;
            goToElement('six-features');

            document.documentElement.style.overflow = 'hidden';

            window.setTimeout(() => {
              allowScroll = true;
            }, 700);
          }
        } else {
          if (
            section.scrollTop < content.current!.clientHeight - 30 &&
            isTouchEnd
          ) {
            allowScroll = false;
            goToElement('six-content');

            document.documentElement.style.overflow = 'auto';

            window.setTimeout(() => {
              allowScroll = true;
            }, 700);
          }
        }

        prevScrollY = scrollY;
      };

      section.addEventListener('scroll', handleChangeScroll);
      section.addEventListener('touchstart', () => {
        isTouchEnd = false;
      });
      section.addEventListener('touchend', () => {
        isTouchEnd = true;
      });
    }
  }, [window.location.hash]);

  return (
    <section className="six-in-tix main__six-in-tix" id={Sections.SIXINTIX}>
      <div className="six-in-tix__container">
        <div className="six-in-tix__content-wrapper">
          <div ref={content} className="six-in-tix__content" id="six-content">
            <h2 className="six-in-tix__title">{t.SIX_IN_TIX.title}</h2>
            <div className="six-in-tix__sub-title">{t.SIX_IN_TIX.text}</div>

            <img src={drum} alt="Drum" className="six-in-tix__drum-mobile" />

            <button onClick={() => goToElement('six-features')}>
              <Icons
                name="arrow-circle"
                customClassName="six-in-tix__next-btn"
              />
            </button>
          </div>

          <div id="six-features" className="six-in-tix__features-section">
            <button
              className="six-in-tix__prev-btn-wrapper"
              onClick={() => goToElement('six-content')}
            >
              <Icons
                name="arrow-circle"
                customClassName="six-in-tix__prev-btn"
              />
            </button>

            <div className="six-in-tix__features-wrapper">
              <button
                onClick={() => togglePage(`#${MenuItems.DASHBOARD}`)}
                className="six-in-tix__feature dashboard-color"
              >
                {t.SIX_IN_TIX['Custom Dashboard']}
              </button>
              <span>-</span>
              <button
                onClick={() => togglePage(`#${MenuItems.SHOP}`)}
                className="six-in-tix__feature shop-color"
              >
                {t.SIX_IN_TIX['Design your Shop']}
              </button>
              <span>-</span>
              <button
                onClick={() => togglePage(`#${MenuItems.SETTINGS}`)}
                className="six-in-tix__feature settings-color"
              >
                {t.SIX_IN_TIX['Easy Setup']}
              </button>
              <span>-</span>
              <button
                onClick={() => togglePage(`#${MenuItems.MARKETING}`)}
                className="six-in-tix__feature marketing-color"
              >
                {t.SIX_IN_TIX['Sell on Socials']}
              </button>
              <span>-</span>
              <button
                onClick={() => togglePage(`#${MenuItems.STATISTICS}`)}
                className="six-in-tix__feature statistics-color"
              >
                {t.SIX_IN_TIX['Combined Statistics']}
              </button>
              <span>-</span>
              <button
                onClick={() => togglePage(`#${MenuItems.FINANCE}`)}
                className="six-in-tix__feature finance-color"
              >
                {t.SIX_IN_TIX['Instant Payment']}
              </button>
            </div>
          </div>
        </div>
        <div className="six-in-tix__drum-desktop-wrapper">
          <img src={drum} alt="Drum" className="six-in-tix__drum-desktop" />
        </div>
      </div>
    </section>
  );
};
